import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.reduce.js";
import { FormQuestionPropertySchema } from "./data";
import { P, match } from 'ts-pattern';

/**
 * Decides if we should use the question's options for the handles
 *
 * Returns true if kind="decision" AND at-least 1 property is format="form-question"
 */
export function shouldUseQuestionOptionsForHandles(nodeTemplate) {
  var _nodeTemplate$propert;
  if ((nodeTemplate === null || nodeTemplate === void 0 ? void 0 : nodeTemplate.kind) !== 'decision') {
    return false;
  }
  return Object.keys(((_nodeTemplate$propert = nodeTemplate.properties) === null || _nodeTemplate$propert === void 0 ? void 0 : _nodeTemplate$propert.properties) || {}).some(function (key) {
    var _nodeTemplate$propert2, _nodeTemplate$propert3;
    var schema = (_nodeTemplate$propert2 = nodeTemplate.properties) === null || _nodeTemplate$propert2 === void 0 ? void 0 : (_nodeTemplate$propert3 = _nodeTemplate$propert2.properties) === null || _nodeTemplate$propert3 === void 0 ? void 0 : _nodeTemplate$propert3[key];
    return FormQuestionPropertySchema.safeParse(schema).success;
  });
}

/**
 * Gets the list of possible answers to a question.  Returns null if there are no possible answers
 */
export function getQuestionOptions(_ref) {
  var _nodeTemplate$propert4, _data$properties;
  var data = _ref.data,
    nodeTemplate = _ref.nodeTemplate,
    components = _ref.components;
  if ((nodeTemplate === null || nodeTemplate === void 0 ? void 0 : nodeTemplate.kind) !== 'decision') {
    return null;
  }
  var firstQuestionPropertyKey = Object.keys(((_nodeTemplate$propert4 = nodeTemplate.properties) === null || _nodeTemplate$propert4 === void 0 ? void 0 : _nodeTemplate$propert4.properties) || {}).find(function (key) {
    var _nodeTemplate$propert5, _nodeTemplate$propert6;
    var schema = (_nodeTemplate$propert5 = nodeTemplate.properties) === null || _nodeTemplate$propert5 === void 0 ? void 0 : (_nodeTemplate$propert6 = _nodeTemplate$propert5.properties) === null || _nodeTemplate$propert6 === void 0 ? void 0 : _nodeTemplate$propert6[key];
    return FormQuestionPropertySchema.safeParse(schema).success;
  });
  if (!firstQuestionPropertyKey) {
    return null;
  }
  var componentKey = (_data$properties = data.properties) === null || _data$properties === void 0 ? void 0 : _data$properties[firstQuestionPropertyKey];
  if (typeof componentKey !== 'string') {
    return null;
  }
  var component = components.find(function (component) {
    return component.key === componentKey;
  });
  if (!component) {
    return null;
  }

  // "select" components in form.io inexplicably nest the "values" property
  // under "data" while other components don't :(
  if ('data' in component && 'values' in component.data && component.data.values.length > 0) {
    return component.data.values;
  }
  if ('values' in component && component.values.length > 0) {
    return component.values;
  }
  return null;
}
export function convertToDictionary(list) {
  return list.reduce(function (map, item) {
    map[item.id] = item;
    return map;
  }, {});
}

/**
 * Tests to see if a type is assignable to a schema
 * Only checking the type string right now
 */
export function isSchemaBAssignableToSchemaA(_ref2) {
  var schemaA = _ref2.schemaA,
    schemaB = _ref2.schemaB;
  return (schemaB === null || schemaB === void 0 ? void 0 : schemaB.type) === (schemaA === null || schemaA === void 0 ? void 0 : schemaA.type);
}

/**
 * Gets the default value for an outcome data value
 */
export function getEmptyOutcomeDataValue(schema) {
  return match(schema)["with"](P.nullish, function () {
    return undefined;
  })["with"]({
    type: 'string'
  }, function () {
    return '';
  })["with"]({
    'x-type': 'form-question-options'
  }, function () {
    return {
      question_key: '',
      option_keys: []
    };
  }).exhaustive();
}